var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tags?.length)?_c('span',{staticClass:"task-tags"},_vm._l((_vm.tags),function(tag,index){return _c('router-link',{key:'tag'+index,staticClass:"__tag",attrs:{"to":_vm.routeOf(tag)}},[_c('tag',{style:(_vm.styleOfTag(tag)),attrs:{"small":"","dark":_vm.isTagDark(tag)}},[_vm._v(" "+_vm._s(tag.contextName)+" ")])],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }